// import { Paper, Typography } from '@mui/material';
// import { useTheme } from 'styled-components';
// import { IContactViewModel } from 'viewModels';
import { NavHeader } from '../../../components';
// import { CardUser } from '../../../components/CardUser';
import { MenuOptionLeftContacts } from '../../../components/MenuOptionLeft/Contacts';

// import { ContactStatus, TypeCardUser } from '../../../types/enums';
import { Body, Container } from '../styles';
// import { ContactController } from '../../../controller/ContactController';

export const Suggestion = () => {
  //const theme = useTheme();
  //const { suggestedContacts, setSuggestedContacts, setContactRequestSent } = useContacts();

  // const handleSendRequestContact = (contact: IContactViewModel) => {
  //   setSuggestedContacts((prev) => {
  //     const newResults = [...prev];
  //     const resultIdx = newResults.findIndex((c) => c.userId === contact.userId);
  //     if (resultIdx !== -1) {
  //       newResults[resultIdx].id = contact.id;
  //       newResults[resultIdx].status = ContactStatus.PENDING;
  //     }
  //     return newResults;
  //   });
  // };

  // const handleCancelRequestContact = async (contactId: string) => {
  //   await ContactController.removeContactById(contactId).then(() => {
  //     setContactRequestSent((prev) => prev.filter((contact) => contact.id !== contactId));
  //     setSuggestedContacts((prev) => {
  //       const newResults = [...prev];
  //       const resultIdx = newResults.findIndex((contact) => contact.id === contactId);
  //       if (resultIdx !== -1) {
  //         newResults[resultIdx].status = undefined;
  //         newResults[resultIdx].isFriend = false;
  //       }
  //       return newResults;
  //     });
  //   });
  // };

  return (
    <Body>
      <NavHeader typeHeader="company" />
      <Container>
        <MenuOptionLeftContacts />
        <div className="cntAll">
          <div className="cnt">
            <p>Não utilizado</p>
            {/* <div className="cntSugestion">
              <div className="title">Sugestões</div>
              {!suggestedContacts.length ? (
                <Paper sx={{ p: 2, bgcolor: theme.colors.background, borderRadius: 4 }}>
                  <Typography color="text" variant="body1">
                    Sem sugestões
                  </Typography>
                  <Typography color="text" variant="caption">
                    <em>Adicione mais contatos, e volte aqui mais tarde...</em>
                  </Typography>
                </Paper>
              ) : (
                suggestedContacts?.map((s) => (
                  <CardUser
                    key={s.userId}
                    currentUser={{
                      ...s.user,
                      isFriend: s.isFriend,
                      contactStatus: s.status,
                    }}
                    typeUserCard={s.isFriend || s.status === ContactStatus.PENDING || s.status === ContactStatus.RELEASED ?
                      TypeCardUser.FRIEND : TypeCardUser.SEND_REQUEST_CONTACT}
                    contact={s}
                    sendRequestContact={(newContact) => handleSendRequestContact(newContact)}
                    removeContact={() => handleCancelRequestContact(s.id)}
                  />
                ))
              )}
            </div> */}
          </div>
        </div>
      </Container>
    </Body>
  );
};
